<div class="comment-popup__container ">
    <div class="cancel_icon">
        <a  (click)="onClose()"><i class="fas fa-times"></i></a>
    </div>
    <div class="add-border__line">
        <div class="content-area">
            <p class="pb-17">Coin ID : {{coin?.reference_id}}</p>
            <p> CoinCuriosity ID: {{coin?.custom_id}}</p>
            <h2 class="uiHeaderTitle">Community Identification Comments</h2>
            <p *ngIf="identifications && identifications.length == 0">There are no Identification comments.</p>
            <div class="list" *ngIf="identifications && identifications.length > 0">
                <ul>
                    <li *ngFor="let item of identifications">({{item.created_at | date:'medium'}}) {{item?.user?.display_name}}: "{{item?.comment}}"</li>
                   
                </ul>
            </div>

            <h2 class="uiHeaderTitle">Community Assessment Comments</h2>
            <p *ngIf="assessments && assessments.length == 0">There are no Assessment comments.</p>
            <div class="list" *ngIf="assessments && assessments.length > 0">
                <ul >
                    <li *ngFor="let item of assessments" >({{item.created_at | date:'medium'}}) {{item?.user?.display_name}}: "{{item?.comment}}"</li>
                   
                </ul>
            </div>
        </div>


    </div>
</div>